import {
  deleteRequest,
  getRequest,
  postRequest,
} from "../../helpers/request.js";

export const TYPES = {
  API_REQUEST: "API_REQUEST",
  API_ERROR: "API_ERROR",
  API_SUCCESS: "API_SUCCESS",

  CREATE_RC_SUCCESS: "CREATE_RC_SUCCESS",
  LIST_RC_SUCCESS: "LIST_RC_SUCCESS",
  DELETE_RC_SUCCESS: "DELETE_RC_SUCCESS",
  UPDATE_RC_SUCCESS: "UPDATE_RC_SUCCESS",
  SHARED_RC_SUCCESS: "SHARED_RC_SUCCESS",

  USER_LIST: "USER_LIST",
  //Added for changing user role and status
  UPDATE_USER: "UPDATE_USER",
  CLEAR_ERROR: "CLEAR_ERROR"
};

export const createComponent = (name) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await postRequest(
      "components",
      { name },
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );

    if (data.isSuccess) {
      alert("Component is created!!");
      dispatch({
        type: TYPES.CREATE_RC_SUCCESS,
        payload: data.component,
      });
    } else {
      alert(
        "Component could not be created.\nPlease try again later."
      );
      dispatch({
        type: TYPES.API_ERROR,
        payload: data.msg,
      });
    }
  } catch (err) {
    alert("Component could not be created.\nPlease try again later.");
    console.log(err);
    dispatch({
      type: TYPES.API_ERROR,
      payload: JSON.stringify(err),
    });
  }
};

export const listComponents = () => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await getRequest(
      "components/list-user-components",
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );

    if (data.isSuccess) {
      dispatch({
        type: TYPES.LIST_RC_SUCCESS,
        payload: data.components
      });
    }
    else {
      alert("Components could not be retrieved.\nPlease try again later.");
      dispatch({
        type: TYPES.API_ERROR,
        payload: data.msg
      });
    }
  } catch (err) {
    alert("Components could not be retrieved.\nPlease try again later.");
    console.log(err);
    dispatch({
      type: TYPES.API_ERROR,
      payload: JSON.stringify(err)
    });
  }
}

export const syncComponent = (rcId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await postRequest(
      `components/${rcId}/sync-rc-to-km`
    );

    if (data.isSuccess) {
      alert("Sync successful!!");
      dispatch({ type: TYPES.API_SUCCESS });
    }
    else {
      const alertMsg = data.msg || "Sync unsuccessful!\nPlease try again after some time";
      alert(alertMsg);
      dispatch({
        type: TYPES.API_ERROR,
        payload: data.msg
      });
    }
  } catch (err) {
    alert("Sync unsuccessful!\nPlease try again after some time");
    console.log(err);
    dispatch({
      type: TYPES.API_ERROR,
      payload: JSON.stringify(err)
    });
  }
}

export const shareComponent = (rcId, userId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await postRequest(
      `components/${rcId}/share`,
      { userId },
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );

    if (data.isSuccess) {
      alert("Share Components updated successfully!");
      dispatch({ type: TYPES.SHARED_RC_SUCCESS, data: { rcId, sharedWithData: data.sharedWithData } });
    } else {
      if (data.msg) {
        alert(data.msg);
      }
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    alert("Share components unsuccessfull!!!");
    console.log(error);
    dispatch({ type: TYPES.API_ERROR, error: JSON.stringify(error) });
  }
}

export const cloneComponent = (name, rcId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await postRequest(
      `components/${rcId}`,
      { name },
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );

    if (data.isSuccess) {
      alert("Component is created!!");
      dispatch({
        type: TYPES.CREATE_RC_SUCCESS,
        payload: data.component
      });
    }
    else {
      alert("Component could not be created.\nPlease try again later.");
      dispatch({
        type: TYPES.API_ERROR,
        payload: data.msg,
      });
    }
  } catch (err) {
    alert("Component could not be created.\nPlease try again later.");
    console.log(err);
    dispatch({
      type: TYPES.API_ERROR,
      payload: JSON.stringify(err),
    });
  }
}

export const deleteComponent = (rcId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await deleteRequest(
      `components/${rcId}`,
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );
    if (data.isSuccess) {
      alert(data.msg);
      dispatch({
        type: TYPES.DELETE_RC_SUCCESS,
        payload: rcId
      });
    }
    else {
      const alertMsg = data.msg || "Component could not be deleted.\nPlease try again later."
      alert(alertMsg);
      dispatch({
        type: TYPES.API_ERROR,
        payload: alertMsg
      });
    }
  } catch (err) {
    alert("Component could not be deleted.\nPlease try again later.");
    console.log(err);
    dispatch({
      type: TYPES.API_ERROR,
      payload: JSON.stringify(err)
    })
  }
}

export const updateComponent = (name, rcId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await postRequest(
      `components/${rcId}/update`,
      { name },
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );

    if (data.isSuccess) {
      alert("Component updated, Thank you!");
      dispatch({
        type: TYPES.UPDATE_RC_SUCCESS,
        payload: { name, rcId }
      });
    }
    else {
      if (data.msg) {
        alert(data.msg);
      }
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    alert(error);
    console.log(error);
    dispatch({
      type: TYPES.API_ERROR,
      payload: JSON.stringify(error)
    });
  }
}

//Added for changing user role and status
export const updateUserSettings = (role, isActive, userId) => async (dispatch) => {
  dispatch({ type: TYPES.API_REQUEST });
  try {
    const { data } = await postRequest(
      `user/${userId}/updateUser`,
      { role, isActive },
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "x-refresh-token": localStorage.getItem("refreshToken"),
          changeOrigin: true,
        },
      }
    );

    if (data.isSuccess) {
      dispatch({
        type: TYPES.UPDATE_USER,
        payload: { role, isActive, userId }
      });
    }
    else {
      if (data.msg) {
        alert(data.msg);
      }
      dispatch({ type: TYPES.API_ERROR, data: data.msg });
    }
  } catch (error) {
    alert(error);
    console.log(error);
    dispatch({
      type: TYPES.API_ERROR,
      payload: JSON.stringify(error)
    });
  }
}
//Added for changing user role and status
export const clearError = () => async (dispatch) => {
  dispatch({ type: TYPES.CLEAR_ERROR });
};

